import { H1 } from '@atoms/Typographies';
import Head from '@organisms/Heads/Head';
import CommonTemplate from '@templates/Common';
import React from 'react';
import styled from 'styled-components';

const Page404 = () => {
    return (
        <CommonTemplate>
            <Head title="お探しのページは見つかりません" />

            <Page404WithStyled>
                <HeadingWithStyled className="mb-4">
                    <H1>Not Found</H1>
                </HeadingWithStyled>
                <ContentWithStyled>
                    <AnnotationWithStyled>
                        お探しのページは見つかりません
                    </AnnotationWithStyled>
                </ContentWithStyled>
            </Page404WithStyled>
        </CommonTemplate>
    );
};

const Page404WithStyled = styled.div`
`
const HeadingWithStyled = styled.div`
`
const ContentWithStyled = styled.div`
    padding: 0 10px;
`
const AnnotationWithStyled = styled.div`
    height: calc(100vh - 200px);
`

export default Page404;